import { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import Courses from "../Courses/Courses";
import CreateCourse from "../CreateCourse/CreateCourse";

const AdminDashboard = () => {
 const { user, loading, logOut, getCourses, courses } = useContext(UserContext);
 useEffect(() => {
  getCourses();
 }, []);

 // <Courses courses={courses} />

 return (
  <>
   {!loading ? (
    <div className="dashboard">
     <h1>Admin Dashboard</h1>
     <p>Welcome {user.username}</p>
     <p
      onClick={() => {
       logOut();
      }}
     >
      Logout
     </p>
     <Link to="/">Homepage</Link>
     <Link to="/create-course">Create Course</Link>

     <br />
     <br />
     <CreateCourse />
     <br />
     <br />

     <Courses courses={courses} isAdmin={user.role === "admin"} />
    </div>
   ) : (
    <div>Loading....</div>
   )}
  </>
 );
};

export default AdminDashboard;
